// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlayCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
            <path
                fill="currentColor"
                d="M33.4716797,21.6064453 C32.9150386,21.269533 32.2705083,21.09375 31.640625,21.09375 C29.6191402,21.09375 28.125,22.7490216 28.125,24.609375 L28.125,50.390625 C28.125,52.2656232 29.6352535,53.90625 31.640625,53.90625 C32.2769523,53.90625 32.9121083,53.7333995 33.47461,53.390184 L54.5683622,40.499559 C55.6054696,39.8583993 56.25,38.7304679 56.25,37.5 C56.25,36.2755381 55.6125015,35.1386726 54.5683578,34.5000006 L33.4716797,21.6064453 Z M37.5,0 C16.7871103,0 0,16.7871103 0,37.5 C0,58.2128897 16.7871103,75 37.5,75 C58.2128897,75 75,58.2128897 75,37.5 C75,16.7871103 58.2128897,0 37.5,0 Z M37.5,67.96875 C20.6982426,67.96875 7.03125,54.3002933 7.03125,37.5 C7.03125,20.6997067 20.6982426,7.03125 37.5,7.03125 C54.3017596,7.03125 67.96875,20.6997067 67.96875,37.5 C67.96875,54.3002933 54.3017596,67.96875 37.5,67.96875 Z"
                transform="translate(.5 .375)"
            />
        </svg>
    );
};

export const playCircleString =
    "%3Csvg focusable='false' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' %3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolygon points='10 8 16 12 10 16 10 8'%3E%3C/polygon%3E%3C/svg%3E";

export default React.memo(PlayCircle);
